import { useParams } from 'react-router-dom'

export const useSiteId = () => {
  const params = useParams() as any
  return Number(params.id)
}
